import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { NumberRange } from '@app/core/interfaces/c5/number-range';
import { formatNumberRange } from '@app/utils/format-number-range';

interface Options {
  includeDdi?: boolean;
}

@Injectable()
@Pipe({
  name: 'formatNumberRange',
  pure: false,
  standalone: false,
})
export class FormatNumberRangePipe implements PipeTransform {
  transform(value: NumberRange, { includeDdi = false }: Options = {}): any {
    if (value == null) {
      return '';
    }

    return formatNumberRange(value, includeDdi);
  }
}
